import styled from "styled-components";

const StylesContainer = styled.div`
  header {
    h4 {
      color: #215054;
      font-size: 18px;
      font-weight: 400;
      line-height: 15px;
      margin: unset;
    }

    .ant-btn {
      height: 36px;
    }

    .ant-btn.ant-btn-icon-only.ant-btn-round {
      width: 36px;
    }
  }
`;

export default StylesContainer;
